<template>
    <div class="spinner-component">
        <i class="fas fa-spin fa-spinner"></i>
    </div>
  </template>
    
  <script>
import { ref, computed, watch } from 'vue'
  
  export default {
    components: { },
    props: {
    },
    setup(props,{emit}) {
        return {
        };
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .spinner-component {
    font-size: 4rem;
  }
  </style>